var exports = {
  "x": "xfd349460--e1049c--offer",
  "eh": "xfd349460--e1049c--room",
  "h_": "xfd349460--e1049c--description",
  "Wc": "xfd349460--e1049c--area",
  "q9": "xfd349460--e1049c--price",
  "O5": "xfd349460--e1049c--offers",
  "nf": "xfd349460--e1049c--link",
  "z8": "xfd349460--e1049c--props-count",
};

module.exports = exports;
